export const FETCH_CHART_OF_ACCOUNT = 'FETCH_CHART_OF_ACCOUNT'
export const CREATE_CHART_OF_ACCOUNT = 'CREATE_CHART_OF_ACCOUNT'
export const UPDATE_CHART_OF_ACCOUNT = 'UPDATE_CHART_OF_ACCOUNT'
export const REMOVE_CHART_OF_ACCOUNT = 'REMOVE_CHART_OF_ACCOUNT'
export const SELECT_CHART_OF_ACCOUNT = 'SELECT_CHART_OF_ACCOUNT'